import { QRCodeSVG } from "qrcode.react";

type QRCodeGeneratorProps = {
  value: string;
  size?: number;
  bgColor?: string;
  fgColor?: string;
  level?: "L" | "M" | "Q" | "H";
};

const QRCodeGenerator = ({
  value,
  size = 128,
  bgColor = "#ffffff",
  fgColor = "#000000",
  level = "L",
}: QRCodeGeneratorProps) => {
  return <QRCodeSVG value={value} size={size} bgColor={bgColor} fgColor={fgColor} level={level} includeMargin />;
};

export default QRCodeGenerator;
